import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./config/queryClient";
import MainLayout from "./layout/MainLayout";
import { ROUTES } from "./constants/routes";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to={ROUTES.home} replace />} />
          <Route path={ROUTES.home} element={<MainLayout />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
